export default __webpack_public_path__ + "static/media/white-cross.f8366d28.svg";